import FormEditProfile from './form-edit-profile'

export default FormEditProfile
